"use strict";

import Localization from './../librairies/Localization';

export default class Alert {
  static success(message) {
    return this.createAlert("success", message);
  }

  static error(message) {
    return this.createAlert("error", message);
  }

  static warning(message) {
    return this.createAlert("warning", message);
  }

  static createAlert(status, message) {
    this.clear();

    message = Localization.Translate(message);
    const alertElement = document.createElement("p");
    alertElement.classList.add("alert");
    alertElement.classList.add(status);
    alertElement.textContent = message;

    // setTimeout(() => {
    //   alertElement.remove();
    // }, 10000);

    const alertsElement = document.querySelector(".alerts");
    alertsElement.appendChild(alertElement);

    // on click fade out
    alertElement.addEventListener("click", () => {
      alertElement.remove();
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return alertElement;
  }

  static clear() {
    const alertElements = document.querySelectorAll(".alert");
    alertElements.forEach((alertElement) => {
      alertElement.remove();
    });
  }
}